









































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import http from '@/services/Http';
import BookMeetingSearch from './Search.vue';
import MeetingRetailerModal from './MeetingRetailerModal.vue';
import SelectedItem from './SelectedItem.vue';
import NewMeetingBookingFlow from './NewMeetingBookingFlow.vue';
import { AutocompleteResult, BackgroundTypes, Retailer } from '@/models/BookMeetingFlow';
import { getDistanceFromLatLonInKm } from './helpers';
import { meetingLog, meetingTable } from '@/services/MeetingBookingLog';

@Component({
    components: {
        Search: BookMeetingSearch,
        MeetingRetailerModal,
        SelectedItem,
        NewMeetingBookingFlow
    },
    directives: {
        focus: {
            inserted(el: HTMLElement) {
                el.focus();
            }
        }
    }
})
class BookMeetingFlowSearch extends Vue {
    @Prop() blockTitle!: string;
    @Prop() blockText!: string;
    @Prop() blockPlaceholder!: string;
    @Prop() overlappingHero!: boolean;
    @Prop() onHero!: boolean;
    @Prop() backgroundColor!: string;
    @Prop() textColor!: string;
    @Prop() onFooter!: boolean;
    @Prop() inMegaMenu!: boolean;
    @Prop() autoCompleteTopMobile!: boolean;
    @Prop() retailerId: string | undefined;
    @Prop() currentCulture!: string;
    @Prop({ type: Boolean, default: false }) blockOnPage!: boolean;
    @Prop({ type: Boolean, default: false }) useNewMeetingBooking!: boolean;
    @Prop({ type: Object, default: () => ({}) }) backgroundTypes!: BackgroundTypes | undefined;
    @Prop({ type: String, default: '' }) bookingSource!: string;

    public retailers: Retailer[] = [];
    public descriptionTitle: string = '';
    private userLocation: { lat: number; lng: number } | null = null;
    public selectedMeetingType: string | null = null;

    private instanceId: string = Math.random().toString(36).slice(2);

    get modalName(): string {
        return `meeting-retailer-modal-${this.retailerId ? this.retailerId : this.instanceId}`;
    }

    get singleRetailer(): Retailer | null {
        if (!this.retailerId) return null;
        return this.retailers.find(r => r.organizationSystemId === this.retailerId) || null;
    }

    get effectiveSingleRetailerNewBooking(): boolean {
        const retailer = this.singleRetailer;
        return (!!retailer && retailer.useNewMeetingBooking) || this.useNewMeetingBooking;
    }

    public created() {
        this.setAsMainView();
        this.fetchStores();
    }

    private setAsMainView() {
        const currentPath = window.location.pathname ? window.location.pathname : '/';

        const isOnBokaMote =
            currentPath.toLowerCase().startsWith('/boka-mote') ||
            currentPath.toLowerCase().startsWith('/booke-mote') ||
            currentPath.toLowerCase().startsWith('/book-et-mode');

        if (this.onHero && isOnBokaMote) {
            const stickyFooter = document.getElementById('footer');
            const defaultFooter: HTMLElement | null = document.querySelector('footer.footer');
            const body = document.body;

            if (body) {
                body.style.overflow = 'hidden';
                body.style.maxHeight = '100vh';
            }

            if (stickyFooter) {
                stickyFooter.style.display = 'none';
            }
            if (defaultFooter) {
                defaultFooter.style.display = 'none';
            }
        }
    }

    public beforeDestroy() {
        if (this.onHero) {
            const stickyFooter = document.getElementById('footer');
            const defaultFooter: HTMLElement | null = document.querySelector('footer.footer');
            const body = document.body;

            if (body) {
                body.style.overflow = 'auto';
                body.style.maxHeight = '';
            }

            if (stickyFooter) {
                stickyFooter.style.display = 'block';
            }
            if (defaultFooter) {
                defaultFooter.style.display = 'block';
            }
        }
    }

    public updateUserLocation(location: { lat: number; lng: number }) {
        this.userLocation = location;
        this.openModal();
    }

    public handleAutocompleteResult(result: AutocompleteResult) {
        this.descriptionTitle = result.description;
    }

    public openModal() {
        this.$modal.show(this.modalName);
    }

    get sortedRetailers(): Retailer[] {
        if (!this.userLocation) {
            return this.retailers;
        }

        const { lat, lng } = this.userLocation;

        return this.retailers
            .map(retailer => {
                const rLat = retailer.position ? retailer.position.lat : null;
                const rLng = retailer.position ? retailer.position.lng : null;

                if (!rLat || !rLng) {
                    return { ...retailer, distance: Infinity };
                }

                const distance = getDistanceFromLatLonInKm(lat, lng, rLat, rLng);
                return { ...retailer, distance };
            })
            .sort((a, b) => {
                const distA = a.distance !== undefined ? a.distance : Infinity;
                const distB = b.distance !== undefined ? b.distance : Infinity;
                return distA - distB;
            })
            .slice(0, 10);
    }

    public fetchStores() {
        http.get('/api/retailer/stores')
            .then((response: any) => response.json())
            .then((data: Retailer[]) => {
                this.retailers = data;
                
                meetingLog('BookMeetingBlock', 'GET /api/retailer/stores returned ' + (data ? data.length : 0) +
                    ' stores (block flag use-new-meeting-booking: ' + this.useNewMeetingBooking + ')');
                meetingTable('BookMeetingBlock', 'stores as delivered by the server',
                    (data || []).map(r => ({
                        name: r.name,
                        organizationSystemId: r.organizationSystemId,
                        useNewMeetingBooking: r.useNewMeetingBooking,
                        availableMeetingTypes: (r.availableMeetingTypes || []).join(', '),
                        bookMeetingUrlStore: r.bookMeetingUrlStore,
                        bookMeetingUrlHome: r.bookMeetingUrlHome,
                        bookMeetingUrlVideo: r.bookMeetingUrlVideo
                    })));
            })
            .catch((e: any) => {
                console.error('Failed to fetch stores:', e);
            });
    }
}

export default BookMeetingFlowSearch;
